import React from 'react';
import LocationTemplate from './LocationTemplate';

const MaconPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Macon"
      stateName="North Carolina"
      countyName="Warren"
      zipCodes={["27551"]}
      latitude={36.4415}
      longitude={-78.0829}
      population={119}
      historicalFact="Small incorporated town in Warren County."
      nearbyTowns={[
        "Warrenton, NC",
        "Henderson, NC",
        "Norlina, NC",
        "Littleton, NC",
        "Soul City, NC",
        "Vaughan, NC",
        "Oxford, NC",
        "Hollister, NC"
      ]}
    />
  );
};

export default MaconPage;